<template>
  <v-chip
    :class="[{[$style.chip]: !light_color}]"
    v-bind="$attrs"
    v-on="$listeners"
    :color="color_by_status"
    :outlined="!is_filled_bg"
    small
  >
    <slot
      v-for="(_, name) in $slots"
      :slot="name"
      :name="name"
    />
  </v-chip>

</template>

<script lang="ts">
import { ChipStatuses } from '@/enums';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ChipStatus extends Vue {
  @Prop({ type: String, default: '' })
  status!: ChipStatuses;

  get color_by_status() {
    switch (this.status) {
      case ChipStatuses.SUCCESS:
        return 'success lighten-3';

      case ChipStatuses.CANCELED:
        return 'primary lighten-5';

      case ChipStatuses.DONE:
        return '#D0FAE8';

      case ChipStatuses.NEW:
        return 'primary lighten-4';

      case ChipStatuses.ERROR:
        return 'error lighten-4';

      case ChipStatuses.WARNING:
        return '#FEF7E4';

      case ChipStatuses.LIGHTEN_3:
        return 'primary lighten-3';

      case ChipStatuses.LIGHTEN_2:
        return 'primary lighten-2';

      case ChipStatuses.LIGHTEN_1:
        return 'primary lighten-1';

      case ChipStatuses.LIGHT:
        return 'primary lighten-4';

      default:
        return 'primary lighten-1';
    }
  }

  get is_filled_bg() {
    return [
      ChipStatuses.SUCCESS,
      ChipStatuses.CANCELED,
      ChipStatuses.DONE,
      ChipStatuses.ERROR,
      ChipStatuses.WARNING,
    ].includes(this.status);
  }

  get light_color() {
    return [ChipStatuses.LIGHT].includes(this.status);
  }
}
</script>

<style module lang="scss">
.chip {
  :global(.v-chip__content) {
    color: $primary_darken1;
  }
}
</style>
